import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface ShiftInfoAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const ShiftInfoAccordion: React.FC<ShiftInfoAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();

  // Use actual data from striive job schema
  // const striive_job = jobData.striive_job;
  // const getValue = (val: any) =>
  //   val !== undefined && val !== null && val !== '' ? val : '-';

  // No explicit shift fields in StriiveJob schema, so fallback to '-'
  const mappedData = {
    shiftDays: '-',
    shiftVariable: '-',
    shiftNights: '-',
    shiftWeekends: '-',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title="SHIFT INFO" expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem('Shift Days:', mappedData.shiftDays)}
        {renderDetailItem('Shift Variable:', mappedData.shiftVariable)}
        {renderDetailItem('Shift Nights:', mappedData.shiftNights)}
        {renderDetailItem('Shift Weekends:', mappedData.shiftWeekends)}
      </Grid>
    </JobAccordion>
  );
};
